import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService, Resource } from './base.service';
import { ResourceType } from '@completion/enums';
import { AdminFormDto, AdminFormListItemDto, GetFormsParams, PaginatedResponse } from '@completion/models';

@Injectable({ providedIn: 'root' })
export class AdminFormService extends BaseService {
  constructor(readonly http: HttpClient) {
    super(http);
  }

  @Resource(ResourceType.AdminFormGetAll)
  getAdminForms(params: GetFormsParams = {}): Observable<PaginatedResponse<AdminFormListItemDto>> {
    const query = new URLSearchParams();

    if (params.search) query.set('search', params.search);
    query.set('page', String(params.page ?? 0));
    query.set('size', String(params.size ?? 20));
    if (params.sort) query.set('sort', params.sort);

    return this.http.get<PaginatedResponse<AdminFormListItemDto>>(`${this.baseUrl}/admin/forms?${query.toString()}`);
  }

  @Resource(ResourceType.AdminFormGetById)
  getAdminForm(_id: number): Observable<AdminFormDto> {
    return this.http.get<AdminFormDto>(`${this.baseUrl}/admin/forms/${_id}`);
    // return this.http.get<AdminForm>(`${this.baseUrl}/admin/forms/${_id}?mock=true`);
  }

  @Resource(ResourceType.AdminFormCreate)
  createAdminForm(_form: Partial<AdminFormDto>): Observable<AdminFormDto> {
    return this.http.post<AdminFormDto>(`${this.baseUrl}/admin/forms`, _form);
  }

  @Resource(ResourceType.AdminFormUpdate)
  updateAdminForm(_form: AdminFormDto): Observable<AdminFormDto> {
    return this.http.put<AdminFormDto>(`${this.baseUrl}/admin/forms/${_form.id}`, _form);
  }

  @Resource(ResourceType.AdminFormDelete)
  deleteAdminForm(_id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/admin/forms/${_id}`);
  }
}
